import { ROUTE_SUBSCRIPTION } from '@/constants/Routes'
import { eventTracker } from '@/config/trackingFunctions'
import { TRACKING_TYPES } from '@/constants/TrackingConstants'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRemoteConfig } from './useRemoteConfig'

/**
 * The upgrade-to-DUPR+ call to action used wherever mobile registers a
 * Superwall paywall placement. Opens the RevenueCat {@link SubscribeModal}
 * when the `enableWebSubscribeModal` remote-config flag allows it, otherwise
 * falls back to the subscription settings page so the CTA never dead-ends.
 *
 * The caller renders `<SubscribeModal open={subscribeOpen} onClose={closeSubscribe} />`.
 * `placement` mirrors mobile's Superwall placement id and is tracked as the
 * analytics event property.
 */
export function useUpgradeCta(placement: string) {
  const [subscribeOpen, setSubscribeOpen] = useState(false)
  const navigate = useNavigate()
  const { getBoolean, isReady } = useRemoteConfig()

  const openUpgrade = useCallback(() => {
    eventTracker(TRACKING_TYPES.UPGRADE_CTA_CLICKED, { placement })
    if (isReady && getBoolean('enableWebSubscribeModal', false)) {
      setSubscribeOpen(true)
    } else {
      navigate(ROUTE_SUBSCRIPTION)
    }
  }, [placement, isReady, getBoolean, navigate])

  const closeSubscribe = useCallback(() => setSubscribeOpen(false), [])

  return { openUpgrade, subscribeOpen, closeSubscribe }
}
